import { Component, OnInit } from '@angular/core';
import { Parametre } from '../../models/parametre.model';
import { ParametreService } from '../../services/parametre.service';
import { AuthService } from '../../services/auth.service';
import { Utilisateur } from '../../models/utilisateur.model';
import { UtilisateurService } from '../../services/utilisateur.service';

@Component({
  selector: 'app-parametres',
  templateUrl: './parametres.component.html',
  styleUrls: ['./parametres.component.css']
})
export class ParametresComponent implements OnInit {

  parametres: Parametre = {
    nomFestival: '', edition: '', dates: '', adresse: '', email: '', telephone: '', facebook: '', instagram: '',
    dateOuverture: '', noteInfo: ''
  };
  messageParametres = '';

  ancienMotDePasse = '';
  nouveauMotDePasse = '';
  confirmationMotDePasse = '';
  messagePassword = '';
  erreurPassword = '';

  // ---------- Gestion des comptes administrateurs ----------
  utilisateurs: Utilisateur[] = [];
  nouvelUtilisateur = { username: '', password: '' };
  messageUtilisateur = '';
  erreurUtilisateur = '';

  constructor(
    private parametreService: ParametreService,
    private authService: AuthService,
    private utilisateurService: UtilisateurService
  ) { }

  ngOnInit(): void {
    this.parametreService.getParametres().subscribe(data => {
      this.parametres = data;
    });
    this.chargerUtilisateurs();
  }

  enregistrerParametres(): void {
    this.parametreService.updateParametres(this.parametres).subscribe(() => {
      this.messageParametres = 'Paramètres enregistrés avec succès !';
      setTimeout(() => this.messageParametres = '', 3000);
    });
  }

  changerMotDePasse(): void {
    this.erreurPassword = '';
    this.messagePassword = '';

    if (this.nouveauMotDePasse.length < 8) {
      this.erreurPassword = 'Le nouveau mot de passe doit contenir au moins 8 caractères.';
      return;
    }
    if (!/[a-zA-Z]/.test(this.nouveauMotDePasse) || !/[0-9]/.test(this.nouveauMotDePasse)) {
      this.erreurPassword = 'Le nouveau mot de passe doit contenir au moins une lettre et un chiffre.';
      return;
    }
    if (this.nouveauMotDePasse !== this.confirmationMotDePasse) {
      this.erreurPassword = 'La confirmation ne correspond pas au nouveau mot de passe.';
      return;
    }

    this.authService.changerMotDePasse(this.ancienMotDePasse, this.nouveauMotDePasse).subscribe({
      next: (reponse) => {
        if (reponse.success) {
          this.messagePassword = 'Mot de passe modifié avec succès !';
          this.ancienMotDePasse = '';
          this.nouveauMotDePasse = '';
          this.confirmationMotDePasse = '';
          setTimeout(() => this.messagePassword = '', 3000);
        } else {
          this.erreurPassword = reponse.message;
        }
      },
      error: () => {
        this.erreurPassword = 'Erreur de connexion au serveur.';
      }
    });
  }

  chargerUtilisateurs(): void {
    this.utilisateurService.getAll().subscribe(data => this.utilisateurs = data);
  }

  ajouterUtilisateur(): void {
    this.erreurUtilisateur = '';
    this.messageUtilisateur = '';

    if (this.nouvelUtilisateur.password.length < 8) {
      this.erreurUtilisateur = 'Le mot de passe doit contenir au moins 8 caractères.';
      return;
    }
    if (!/[a-zA-Z]/.test(this.nouvelUtilisateur.password) || !/[0-9]/.test(this.nouvelUtilisateur.password)) {
      this.erreurUtilisateur = 'Le mot de passe doit contenir au moins une lettre et un chiffre.';
      return;
    }

    this.utilisateurService.creer(this.nouvelUtilisateur.username, this.nouvelUtilisateur.password).subscribe({
      next: (reponse) => {
        if (reponse.success) {
          this.messageUtilisateur = 'Administrateur ajouté avec succès !';
          this.nouvelUtilisateur = { username: '', password: '' };
          this.chargerUtilisateurs();
          setTimeout(() => this.messageUtilisateur = '', 3000);
        } else {
          this.erreurUtilisateur = reponse.message || "Erreur lors de l'ajout.";
        }
      },
      error: () => this.erreurUtilisateur = 'Erreur de connexion au serveur.'
    });
  }

  supprimerUtilisateur(utilisateur: Utilisateur): void {
    if (utilisateur.id === undefined) return;
    if (!confirm(`Supprimer le compte "${utilisateur.username}" ? Cette action est définitive.`)) return;

    this.utilisateurService.supprimer(utilisateur.id).subscribe(reponse => {
      if (reponse.success) {
        this.chargerUtilisateurs();
      } else {
        alert(reponse.message);
      }
    });
  }
}
